<template>
    <div>
        <commBanner :obj="obj"></commBanner>
        <titleHead :headTitle="headTitle"></titleHead>
        <div class="w80 mb-30">
            <el-container>
              <el-aside width="330px">
                 <sidebar></sidebar>
              </el-aside>
              <el-main>
                <companySide v-if="type" :isButton="isButton" @release ="gorelease()"></companySide>
                 <headSide v-else @release ="gorelease()"></headSide>
                 <div class="mt-30">
                    <contTitle :obj="obj" :contTitle="contTitle"></contTitle>
                    <div class="content">
                       <div class="cont_list" v-for="(item,index) in list" :key="index">
                         <router-link :to="{path:'/environmental_college_detail',query:{id:item.goodsId}}">
                            <div class="vide">
                               <img :src="item.goodscover">
                                <img class="model" src="@/assets/images/play.png" />
                            </div>
                            <div class="">
                                <p class="list_title ">{{item.goodsName}}</p>
                                <p class="list_text"><span>主讲人：</span><span>{{item.fistprofessorname}} </span></p>
                                <div class="fdc">
                                  <p class="list_text">
                                    <span>观看时间:</span>
                                    <span v-if="item.transDate">{{item.transDate.substring(0,10)}}</span>
                                  </p>
                                  <p class="list_num">
                                      <span class="ft14 mr6">￥</span>
                                      <span>{{item.amount}}</span>
                                  </p>
                                </div>
                            </div>
                         </router-link>     
                       </div>
                    </div>

                    <!--分页-->
                    <Pagination v-show="total>0"   :total="total"  :page.sync="listQuery.curPage" :limit.sync="listQuery.limit" @pageChange="pageChange" ></Pagination>

                     <div style="margin-top:20%;">
                       <notList :notCode="notCode"></notList>
                    </div>
                 </div>
              </el-main>
            </el-container>
        </div>
    </div>
</template>
<script>
import {myCollegeList} from "@/api/coment"
import sidebar from '../../common/sidebar'
import headSide from '../../common/headSide'
import companySide from "../../common/companySide";
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import contTitle from '../../common/contTitle'
import Pagination from '../../components/Pagination'
import notList from '../../common/notList'
export default {
  components:{
      sidebar,headSide,companySide,commBanner,titleHead,contTitle,Pagination,notList
  },
  data(){
      return{
        contTitle:'我的课程',
        headTitle:'我的课程',
        obj:{
            title:'我的课程',        
            contCount:"",
            isShow:true,
            roleType:'',
            personalType:9
            // content:'公司主营产品及服务包括:金属氧化物避雷器带电检测仪、数字式钳形伏安相位表、大型地网接地电阻测量仪、多通道波形记录仪、PT感应耐压试验电源、高压高稳定电源...',
            // bannerUrl:require('@/assets/images/banner.jpg')
        },
        list:[],
        listQuery:{
          curPage:1,
          limit:6
        },
        total:0,//总条数
        notCode:false,
        type:false,
        isButton:false
      }
  },
  created(){
    this.getList();
    let  type = this.$store.state.user.userInfo.type;
    this.obj.roleType = type;
    if(type == 3){
        this.type = true;
        this.contTitle = '观看课程'
        this.headTitle = '企业课堂';
        this.obj.title = '企业课堂';
    }
  },
  methods:{
    //列表
    getList(){
      myCollegeList(this.listQuery).then((res)=>{
        if(res.code == 0){
          res.page.list.forEach((item)=>{
            if(item.goodsotherinfo2 == '0'){
              this.list.push(item)
            }
          });
           this.total = this.list.length;
           this.obj.contCount = res.page.totalCount;
           this.obj.contCount = this.list.length;
        }
           this.list.length == 0 ? this.notCode = true : this.notCode = false;
      }).catch((err)=>{})
    },
    //分页
    pageChange(item){
      this.listQuery['curPage'] = item.page;
      this.listQuery['limit'] = item.limit;
      this.getList();
    },
    //发布需求
    gorelease(){
       this.$router.push('/demand')
    }
  },  
}
</script>
<style scoped>
.ft14{
  font-size: 14px;
}
.mr6{
  margin-right: -6px;
}
.mt20{
  margin-top: 20px;
}
.content{
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.content:after{
  content: '';
  width: 218px;
}
.cont_list{
  width: 31%;
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-bottom: 20px;
}
.vide{
  height: 145px;
  overflow: hidden;
  position: relative;
}
.vide img{
   /* width:263px ; */
   width: 100%;
   height: 100%;
   transition: all 0.6s;
}
.vide img:nth-child(1):hover{
   transform: scale(1.4);
}
.model{
 position: absolute;
  width: 50px !important;
  height: 50px !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}


.list_title{ 
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  margin-top: 10px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.list_text{
  margin-top: 5px;
}
.list_text span{  
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9A9A9A;
}
.list_num{ 
  font-size: 20px;
  font-family: Arial;
  font-weight: 400;
  color: #FF7402;
}
.el-pagination{
   margin-top: 40px;
}
</style>


// WEBPACK FOOTER //
// src/view/coment/curriculum.vue